export default __webpack_public_path__ + "static/media/img-teams_2.ff35933a.svg";